import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const upcomingData = [
  { invoice: 'INV-3060', vendor: 'BioGen', amount: '₹92,000', dueDate: '18 Aug 2026', days: 0, status: 'Due today' },
  { invoice: 'INV-3063', vendor: 'Vedica Store', amount: '₹1,18,000', dueDate: '23 Aug 2026', days: 5, status: 'Due in 5 days' },
  { invoice: 'INV-3072', vendor: 'BioGen', amount: '₹70,000', dueDate: '20 Aug 2026', days: 2, status: 'Due in 2 days' },
  { invoice: 'INV-3075', vendor: 'Vedica Store', amount: '₹50,000', dueDate: '21 Aug 2026', days: 3, status: 'Due in 3 days' },
  { invoice: 'INV-3067', vendor: 'AHB Pharma', amount: '₹1,60,000', dueDate: '10 Sep 2026', days: 23, status: 'Due in 23 days' },
  { invoice: 'INV-3070', vendor: 'HealthCorp', amount: '₹88,500', dueDate: '25 Sep 2026', days: 38, status: 'Due in 38 days' },
];

export default function UpcomingPaymentsCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Upcoming Payments</h3>
      </div>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Invoice</TableCell>
              <TableCell>Vendor</TableCell>
              <TableCell align="right">Amount</TableCell>
              <TableCell align="right">Due Date</TableCell>
              <TableCell align="right">Days</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {upcomingData.map((row) => (
              <TableRow key={row.invoice} hover>
                <TableCell>{row.invoice}</TableCell>
                <TableCell><span className="vendor-link">{row.vendor}</span></TableCell>
                <TableCell align="right">{row.amount}</TableCell>
                <TableCell align="right">{row.dueDate}</TableCell>
                <TableCell align="right">{row.days}</TableCell>
                <TableCell>
                  <span className={`pill ${row.days === 0 ? 'red' : row.days <= 7 ? 'amber' : 'blue'}`}>
                    {row.status}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
